'use strict';

const BaseStore = require('fluxible/addons/BaseStore');

class UserToUserMessageStore extends BaseStore {

    constructor(dispatcher) {
        super(dispatcher);
        this._init();
    }

    _init() {
        this.message = {
            fromName: '',
            fromEmail: '',
            fromUserId: '',
            toName: '',
            toEmail: '',
            toUserId: '',
            bcc: '',
            subject: '',
            body: '',
            templateFolder: '',
            template: ''
        };
    }

    doneLoading(payload) {
        const { user, copyText, contactName, contactEmail } = payload;

        if (user) {
            this.message.fromUserId = user.pick('id');
            this.message.fromName = ([user.get('profile.firstName') || '', user.get('profile.lastName') || ''].join(' ')).trim();
            this.message.fromEmail = user.get('profile.email');
        }

        this.message.toName = contactName;
        this.message.toEmail = contactEmail;

        this.message.subject = copyText.get('subject');
        this.message.templateFolder = copyText.get('templateFolder');
        this.message.template = copyText.get('template');

        this.emitChange();
    }

    editField(payload) {
        this.message[payload.field] = payload.value;
        this.emitChange();
    }
}

UserToUserMessageStore.storeName = 'UserToUserMessageStore';

UserToUserMessageStore.handlers = {
    'contact:userToUser:message:fieldEdited': 'editField',
    'contact:userToUser:loading:done': 'doneLoading'
};

module.exports = UserToUserMessageStore;



// WEBPACK FOOTER //
// ./assets/js/contact/userToUser/stores/UserToUserMessageStore.es.js